import React, { useEffect, useRef } from "react";
import "./CandlelightCursor.css";

const CandlelightCursor = ({ isActive }) => {
  const cursorRef = useRef(null);

  useEffect(() => {
    if (!isActive) return;

    const cursor = cursorRef.current;
    
    const handleMouseMove = (e) => {
      const x = e.clientX;
      const y = e.clientY;
      
      if (cursor) {
        cursor.style.left = x + 'px';
        cursor.style.top = y + 'px';
      }
      
      // Update CSS custom properties for the spotlight position
      document.body.style.setProperty('--mouse-x', x + 'px');
      document.body.style.setProperty('--mouse-y', y + 'px');
    };

    // Hide default cursor and add candlelight body class
    document.body.style.cursor = 'none';
    document.body.classList.add('candlelight-mode');
    
    // Add mouse move listener
    document.addEventListener('mousemove', handleMouseMove);
    
    // Try to get current mouse position or fallback to toggle position
    const initializePosition = () => {
      // Try to find the theme toggle element to start from its position
      const toggleElement = document.querySelector('.theme-toggle');
      if (toggleElement) {
        const rect = toggleElement.getBoundingClientRect();
        const toggleX = rect.left + rect.width / 2;
        const toggleY = rect.top + rect.height / 2;
        handleMouseMove({ clientX: toggleX, clientY: toggleY });
      } else {
        // Fallback to center if toggle not found
        handleMouseMove({ clientX: window.innerWidth / 2, clientY: window.innerHeight / 2 });
      }
    };
    
    // Small delay to ensure DOM is ready
    setTimeout(initializePosition, 10);
    
    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.body.style.cursor = 'auto';
      document.body.classList.remove('candlelight-mode');
    };
  }, [isActive]);

  if (!isActive) return null;

  return (
    <div ref={cursorRef} className="candlelight-cursor">
      <div className="candle-flame">🕯️</div>
    </div>
  );
};

export default CandlelightCursor;